// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_d23f884","label":"_576efb4"};